var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93612 3H4.21622C3.54545 3 3 3.54545 3 4.21622V9.92875C3 10.5995 3.54545 11.145 4.21622 11.145H9.92875C10.5995 11.145 11.145 10.5995 11.145 9.92875V4.21622C11.1523 3.54545 10.6069 3 9.93612 3ZM9.6855 4.45946V9.6855H4.45946V4.45946H9.6855Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7838 3H14.0713C13.4005 3 12.855 3.54545 12.855 4.21622V9.92875C12.855 10.5995 13.4005 11.145 14.0713 11.145H19.7838C20.4545 11.145 21 10.5995 21 9.92875V4.21622C21 3.54545 20.4545 3 19.7838 3ZM19.5332 4.45946V9.6855H14.3071V4.45946H19.5332Z",
    fill: "#838383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93612 12.8477H4.21622C3.54545 12.8477 3 13.3931 3 14.0639V19.7764C3 20.4472 3.54545 20.9926 4.21622 20.9926H9.92875C10.5995 20.9926 11.145 20.4472 11.145 19.7764V14.0639C11.1523 13.3931 10.6069 12.8477 9.93612 12.8477ZM9.6855 14.3145V19.5405H4.45946V14.3145H9.6855Z",
    fill: "#838383"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9238 12.8477C14.6757 12.8477 12.8477 14.6757 12.8477 16.9238C12.8477 19.172 14.6757 21 16.9238 21C19.172 21 21 19.172 21 16.9238C21 14.6757 19.172 12.8477 16.9238 12.8477ZM19.5332 16.9238C19.5332 18.3612 18.3612 19.5332 16.9238 19.5332C15.4865 19.5332 14.3145 18.3612 14.3145 16.9238C14.3145 15.4865 15.4865 14.3145 16.9238 14.3145C18.3612 14.3145 19.5332 15.4865 19.5332 16.9238Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7f0fe6455cb079c3183f50796825e362.svg";
export { ForwardRef as ReactComponent };